export function updateUserLanguageSettings(language) {
    return `mutation {
      updateUserLanguageSettings (
        language: "${language}"
      ){
        message {
          isRequestSuccessful
          message
          id
        }
        userSettings {
          id
          uiLanguage
        }
      }
    }`;
  };